import { User } from "../@core/data/users";

export default class CourseRating {
  id?: string;
  title?: string;
  description?: string;
  rating?: number;
  courseId?: string;

  // userName?: string;

  refTitle?: string;
  toUid?: string;

  //Moderator
  isReviewed?: boolean;
  isApproved?: boolean;
  approvedOn?: Date;
  approvedBy?: string;
  approvedAuthor?: User;

  //default
  timestamp?: number;
  author?: User;
  createdBy?: string;
  createdOn?: Date;
  updatedBy?: string;
  updatedOn?: Date;
  isDeleted?: boolean;
  isActive?: boolean;
  visibility?: string;
  accessToken?: string;
}
